import scrollStore from '../modules/scroll/scroll.store';
import resizeStore from '../modules/resize/resize.store';

var getIEVersion = function() {
	var rv = -1;
	if (navigator.appName == 'Microsoft Internet Explorer') {
		var ua = navigator.userAgent;
		var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
		if (re.exec(ua) != null)
			rv = parseFloat( RegExp.$1 );
	}
	return rv;
}

var offsetFrom = function(elem, parent) {
	function getOffsetSum(elem) {
		var top = 0, left = 0;
		while(elem && elem !== parent) {
			top = top + parseInt(elem.offsetTop);
			left = left + parseInt(elem.offsetLeft);
			elem = elem.offsetParent;
		}

		return {top: top, left: left};
	}
	return getOffsetSum(elem);
}

var offset = function(elem) {
	var data = Date.now();
	function getOffsetSum(elem) {
		var top = 0, left = 0;
		while(elem) {
			top = top + parseInt(elem.offsetTop);
			left = left + parseInt(elem.offsetLeft);
			elem = elem.offsetParent;
		}

		return {top: top, left: left};
	}

	function getOffsetRect(elem) {
		var box = elem.getBoundingClientRect();

		var body = document.body;
		var docElem = document.documentElement;

		var scrollTop = window.pageYOffset  || docElem.scrollTop || body.scrollTop;
		var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

		var clientTop = docElem.clientTop   || body.clientTop || 0;
		var clientLeft = docElem.clientLeft || body.clientLeft || 0;

		var top  = box.top  + scrollTop  - clientTop;
		var left = box.left + scrollLeft - clientLeft;

		return {
			top:  Math.round(top),
			left: Math.round(left)
		};
	}

	// if (elem.getBoundingClientRect) {
	// 	return getOffsetRect(elem);
	// } else {
	return getOffsetSum(elem);
	// }
}

var onScreen = function(query) {
	var scrolled = scrollStore.getData().top;
	var elements = [];
	var ww = resizeStore.getData().width;
	var	wh = resizeStore.getData().height;

	var allElements = Array.prototype.slice.call(document.querySelectorAll(query));

	allElements.forEach(function(el) {
		var of;
		var ot, ol, w, h;

		if (el.style.visibility === 'hidden' || // just check for js props
			el.style.display === 'none') return;

		of = offset(el);
		ot = of.top;
		ol = of.left;
		h = el.clientHeight;
		w = el.clientWidth;

		if (scrolled + wh >= ot &&
			scrolled <= ot + h) {
			elements.push(el);
		}
	});

	return elements;
}

var queryParse = function (str) {
	if (typeof str !== 'string') {
		return {};
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return {};
	}

	return str.split('&').reduce(function (ret, param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		var key = parts[0];
		var val = parts[1];

		key = decodeURIComponent(key);

		val = val === undefined ? null : decodeURIComponent(val);

		if (!ret.hasOwnProperty(key)) {
			ret[key] = val;
		} else if (Array.isArray(ret[key])) {
			ret[key].push(val);
		} else {
			ret[key] = [ret[key], val];
		}

		return ret;
	}, {});
}

export {
	offset,
	offsetFrom,
	onScreen,
	queryParse,
	getIEVersion,
}